import { isCampaignActive } from 'src/components/SponsoredListings/SponsoredListings.util';
import {
  getEventPerformerVenue,
  getIsSponsoredListingsEligibleEvent,
} from 'src/utils/eventWithDataUtils';
import {
  CatalogResults,
  EventWithData,
  SponsoredListingsCampaign,
} from 'src/WebApiController';

/**
 * Picks the campaign to open for an event, mirroring BoostListingButton:
 * prefer active campaigns (first the one with an active flight), fall back to
 * any campaign when none are active, and null when the event has none.
 */
export const pickCampaignForEvent = (
  allCampaignData:
    | Record<number, SponsoredListingsCampaign[]>
    | null
    | undefined,
  viagId: number
): SponsoredListingsCampaign | null => {
  if (!allCampaignData) {
    return null;
  }

  const allCampaigns = allCampaignData[viagId] ?? [];
  let activeCampaigns = allCampaigns.filter((c) => isCampaignActive(c));

  if (activeCampaigns.length === 0) {
    activeCampaigns = allCampaigns;
  }

  const campaignWithActiveFlight = activeCampaigns.find((c) => c.activeFlight);
  return campaignWithActiveFlight ?? activeCampaigns[0] ?? null;
};

/**
 * Whether an event can be boosted at all: it must be mapped to a viagogo
 * event (pending/rejected events cannot be targeted by a campaign) and the
 * venue country must be allowed for sponsored listings for this account.
 */
export const isEventBoostEligible = (
  eventData: EventWithData,
  catalog: CatalogResults | null | undefined,
  allowedCountryCodes: string[] | null | undefined
): boolean => {
  if (eventData.event.viagId == null) {
    return false;
  }
  const { venue } = getEventPerformerVenue(eventData.event.virtId, catalog);
  return getIsSponsoredListingsEligibleEvent(
    venue?.ctryCode,
    allowedCountryCodes ?? undefined
  );
};
